import React, { useContext, createContext, useReducer } from 'react'
import reducer, { ReducerAction } from './reducer'

interface UploaderProps {
  product: any
  children: any
}

interface UploaderContext {
  product: any
  uploaders: any[]
  dispatch: React.Dispatch<ReducerAction>
}

const UploaderContext = createContext<UploaderContext>({
  product: null,
  uploaders: [],
  dispatch: () => null,
})

export default function UploaderProvider({ product, children }: UploaderProps) {
  const [uploaders, dispatch] = useReducer(reducer, [])

  const context = {
    product,
    uploaders,
    dispatch,
  }

  return (
    <UploaderContext.Provider value={context}>
      {children}
    </UploaderContext.Provider>
  )
}

export function useUploader() {
  return useContext(UploaderContext)
}
